import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Transition from "@/common/react/Transition";

export default function ProductsSliderModalMobile({
  isOpen,
  products,
  closeModal,
  currentProductSlideIdx,
  setActiveHotspot,
}) {
  const modalSlider = useRef(null);

  useEffect(() => {
    if (isOpen) {
      modalSlider.current.swiper.slideTo(currentProductSlideIdx + 1);
    }
  }, [currentProductSlideIdx]);

  const slideEls = products?.map((product, index) => {
    if (!product.handle) return null;
    return (
      <SwiperSlide key={index}>
        <div className="slide-content">
          <div className="image-container">
            <a href={`/products/${product.handle}`}>
              <img
                className="Image--lazyLoad"
                src={window.resizeImage(product.featured_image, 1, 1)}
                data-src={window.resizeImage(product.featured_image, 768)}
                alt="Shop The Look Image"
              />
            </a>
          </div>
        </div>
      </SwiperSlide>
    );
  });

  return (
    <Transition
      enter="transition-slide-from-bottom"
      enterFrom="translate-from-bottom"
      enterTo="translate-to-bottom"
      leave="transition-slide-from-bottom"
      leaveFrom="translate-to-bottom"
      leaveTo="translate-from-bottom"
      show={isOpen}
      appear
    >
      <div className="products-slider-modal--mobile">
        <div className="card">
          <div className="card-header">
            <span onClick={() => closeModal()} className="close-button">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </span>
            <h2>SHOP THE LOOK</h2>
          </div>
          <Swiper
            ref={modalSlider}
            spaceBetween={2}
            loop
            slidesPerView={1}
            initialSlide={currentProductSlideIdx}
            onSlideChange={(swiper) => {
              setActiveHotspot(swiper.activeIndex);
            }}
          >
            {slideEls}
          </Swiper>
        </div>
      </div>
    </Transition>
  );
}
